<template>
  <div class="billInfo">
    <Steps :active="4"></Steps>
    <div>
      <van-collapse v-model="activeNames">
        <van-collapse-item title="商户T0结算费率" name="1">
          <van-field
            v-model="billInfo.agentRateList[0].mercDebitCardRate"
            type="number"
            label="借记卡费率(%)"
            maxlength="6"
            :disabled="isDisabled"
            placeholder="精确到小数点后四位"
            @blur="validateRate(billInfo.agentRateList[0], 'mercDebitCardRate')"
            :error-message="validates['00'].mercDebitCardRate"
          />
          <van-field
            v-model="billInfo.agentRateList[0].mercCreditCardRate"
            type="number"
            label="贷记卡费率(%)"
            maxlength="6"
            :disabled="isDisabled"
            placeholder="精确到小数点后四位"
            @blur="validateRate(billInfo.agentRateList[0], 'mercCreditCardRate')"
            :error-message="validates['00'].mercCreditCardRate"
          />
          <van-field
            v-model="billInfo.agentRateList[0].mercDebitCardTop"
            type="number"
            label="借记卡封顶"
            :disabled="isDisabled || $store.state.disabledT0"
            placeholder="精确到小数点后一位"
            @blur="validateFeetop(billInfo.agentRateList[0], 'mercDebitCardTop')"
            :error-message="validates['00'].mercDebitCardTop"
          />
        </van-collapse-item>
        <van-collapse-item title="商户VIPT0结算费率" name="5">
          <van-field
            v-model="billInfo.agentRateList[3].mercDebitCardRate"
            type="number"
            label="借记卡费率(%)"
            maxlength="6"
            disabled
            placeholder="精确到小数点后四位"
            @blur="validateRate(billInfo.agentRateList[3], 'mercDebitCardRate')"
            :error-message="validates['03'].mercDebitCardRate"
          />
          <van-field
            v-model="billInfo.agentRateList[3].mercCreditCardRate"
            type="number"
            label="贷记卡费率(%)"
            maxlength="6"
            disabled
            placeholder="精确到小数点后四位"
            @blur="validateRate(billInfo.agentRateList[3], 'mercCreditCardRate')"
            :error-message="validates['03'].mercCreditCardRate"
          />
          <van-field
            v-model="billInfo.agentRateList[3].mercDebitCardTop"
            type="number"
            label="借记卡封顶"
            disabled
            placeholder="精确到小数点后一位"
            @blur="validateFeetop(billInfo.agentRateList[3], 'mercDebitCardTop')"
            :error-message="validates['03'].mercDebitFeetop"
          />
        </van-collapse-item>
        <van-collapse-item title="商户T1结算费率" name="2">
          <van-field
            v-model="billInfo.agentRateList[1].mercDebitCardRate"
            type="number"
            label="借记卡费率(%)"
            maxlength="6"
            :disabled="isDisabled"
            placeholder="精确到小数点后四位"
            @blur="validateRate(billInfo.agentRateList[1], 'mercDebitCardRate')"
            :error-message="validates['01'].mercDebitCardRate"
          />
          <van-field
            v-model="billInfo.agentRateList[1].mercCreditCardRate"
            type="number"
            label="贷记卡费率(%)"
            maxlength="6"
            :disabled="isDisabled"
            placeholder="精确到小数点后四位"
            @blur="validateRate(billInfo.agentRateList[1], 'mercCreditCardRate')"
            :error-message="validates['01'].mercCreditCardRate"
          />
          <van-field
            v-model="billInfo.agentRateList[1].mercDebitCardTop"
            type="number"
            label="借记卡封顶"
            :disabled="isDisabled || $store.state.disabledT1"
            placeholder="精确到小数点后一位"
            @blur="validateFeetop(billInfo.agentRateList[1], 'mercDebitCardTop')"
            :error-message="validates['01'].mercDebitCardTop"
          />
        </van-collapse-item>
        <van-collapse-item title="商户云闪付结算费率" name="3">
          <van-field
            v-model="billInfo.agentRateList[2].mercDebitCardRate"
            type="number"
            label="借记卡费率(%)"
            maxlength="6"
            disabled
            placeholder="精确到小数点后四位"
            @blur="validateRate(billInfo.agentRateList[2], 'mercDebitCardRate')"
            :error-message="validates['02'].mercDebitCardRate"
          />
          <van-field
            v-model="billInfo.agentRateList[2].mercCreditCardRate"
            type="number"
            label="贷记卡费率(%)"
            maxlength="6"
            disabled
            placeholder="精确到小数点后四位"
            @blur="validateRate(billInfo.agentRateList[2], 'mercCreditCardRate')"
            :error-message="validates['02'].mercCreditCardRate"
          />
          <van-field
            value="无"
            type="text"
            label="借记卡封顶"
            disabled
            placeholder="精确到小数点后一位"
          />
        </van-collapse-item>
        <van-collapse-item title="商户扫码结算费率" name="4">
          <van-field
            v-model="billInfo.agentScanVo.mercWeixinFee"
            type="number"
            label="扫码费率(%)"
            maxlength="6"
            disabled
            placeholder="精确到小数点后四位"
            @blur="validateFee"
            :error-message="errorMessageFee"
          />
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="padding_box">
      <button class="btn" @click="submit">提交审核</button>
    </div>
  </div>
</template>

<script>
import { Field, Cell, Radio, RadioGroup, Collapse, CollapseItem, Dialog } from 'vant';
import Steps from '@/components/Steps.vue';
export default {
  name: 'billInfoMerchant',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Dialog.name]: Dialog,
    Steps
  },
  data() {
    return {
      activeNames: ['1'],
      isDisabled: false,
      errorMessageFee: '',
      billInfo: {
        agentScanVo: {
          mercAlipayFee: '0.3800',
          mercWeixinFee: '0.3800',
          mercYinlianFee: '0.3800'
        },
        agentRateList: [{
          payType: '00',
          mercDebitCardRate: '',
          mercCreditCardRate: '',
          mercDebitCardTop: '',
          mercSingleT0Cost: '0'
        }, {
          payType: '01',
          mercDebitCardRate: '',
          mercCreditCardRate: '',
          mercDebitCardTop: ''
        }, {
          payType: '02',
          mercDebitCardRate: '0.3800',
          mercCreditCardRate: '0.3800',
          mercDebitCardTop: '0'
        },{
          payType: '03',
          mercDebitCardRate: '',
          mercCreditCardRate: '',
          mercDebitCardTop: '',
          mercSingleT0Cost: '0'
        }]
      },
      validates: {
        '00': {
          mercDebitCardRate: '',
          mercCreditCardRate: '',
          mercDebitCardTop: ''
        },
        '01': {
          mercDebitCardRate: '',
          mercCreditCardRate: '',
          mercDebitCardTop: ''
        },
        '02': {
          mercDebitCardRate: '',
          mercCreditCardRate: '',
          mercDebitCardTop: ''
        },
        '03': {
          mercDebitCardRate: '',
          mercCreditCardRate: '',
          mercDebitCardTop: ''
        }
      },
      minRateConsume: 0,
      maxRateConsume: 1,
      upRateValue: 0
    };
  },
  created() {
    const detail = this.$store.state.agentDetail;
    if (detail.profitType) {
      this.billInfo.agentScanVo = detail.agentScanVo;
      this.billInfo.agentRateList.forEach((item, index) => {
        Object.keys(item).forEach(key => {
          let result = detail.agentRateList.filter(value => value.payType === item.payType)[0];
          item[key] = result[key] || 0;
          if (key === 'mercDebitCardRate' || key === 'mercCreditCardRate') {
            item[key] = this.returnFloat(item[key]);
          }
        });
      });
    }
    if (this.$store.state.currentSystem === 'web') {
      this.billInfo = {
        agentScanVo: {
          mercAlipayFee: '0.3800',
          mercWeixinFee: '0.3800',
          mercYinlianFee: '0.3800'
        },
        agentRateList: [{
          payType: '00',
          mercDebitCardRate: '0.6000',
          mercCreditCardRate: '0.6000',
          mercDebitCardTop: '25',
          mercSingleT0Cost: '0'
        }, {
          payType: '01',
          mercDebitCardRate: '0.6000',
          mercCreditCardRate: '0.6000',
          mercDebitCardTop: '25'
        }, {
          payType: '02',
          mercDebitCardRate: '0.3800',
          mercCreditCardRate: '0.3800',
          mercDebitCardTop: '0'
        },{
          payType: '03',
          mercDebitCardRate: '0.6000',
          mercCreditCardRate: '0.6000',
          mercDebitCardTop: '25',
          mercSingleT0Cost: '0'
        }]
      };
      const rateInfo = this.$store.state.rateInfo;
      if (rateInfo.checkVersion === 1 || this.$store.state.version === '1') {
        this.isDisabled = true;
        this.billInfo.agentRateList.forEach((item, index) => {
          Object.keys(item).forEach(key => {
            let result = rateInfo.agentRateTempInfoVoList.filter(value => value.payType === item.payType)[0];
            item[key] = result[key] || 0;
            if (key === 'debitCardRate' || key === 'creditCardRate') {
              item[key] = this.returnFloat(item[key]);
            }
          });
        });
        Object.keys(this.billInfo.agentScanVo).forEach(key => {
          this.billInfo.agentScanVo[key] = rateInfo.agentRateTempInfoVoList.filter(value => value.payType === '04')[0].mercDebitCardRate;
        });
      } else {
        this.getRateRange();
      }
    } else {
      this.getRateRange();
    }
    if (this.$store.state.disabledT0) {
      let result = this.billInfo.agentRateList.filter(item => item.payType === '00')[0];
      result.mercDebitCardTop = 0;
    }
    if (this.$store.state.disabledT1) {
      let result = this.billInfo.agentRateList.filter(item => item.payType === '01')[0];
      result.mercDebitCardTop = 0;
    }
  },
  methods: {
    getRateUpValue() {
      this.$http.post({
        url: '/csps-api/agentInfo/getSysConfValue',
        data: {
          agentId: this.$store.state.agentInfo.pagentId
        }
      }).then(res => {
        console.log(res);
        this.upRateValue = res.data.result.sysConfUpValue;
        if (this.$store.state.currentSystem === 'web') {
          let result_00 = this.billInfo.agentRateList.filter(value => value.payType === '00')[0];
          let result_03 = this.billInfo.agentRateList.filter(value => value.payType === '03')[0];
          result_03.mercCreditCardRate = this.returnFloat(parseFloat(result_00.mercCreditCardRate) + (parseFloat(this.upRateValue) || 0));
          result_03.mercDebitCardRate = this.returnFloat(parseFloat(result_00.mercDebitCardRate) + (parseFloat(this.upRateValue) || 0));
        }
      }).catch(error => {
        console.log(error);
      });
    },
    getRateRange() {
      this.$http.post({
        url: '/csps-api/agentInfo/selectAgentQJValue',
        data: {
          agentId: this.$store.state.agentInfo.pagentId
        }
      }).then(res => {
        console.log(res);
        this.minRateConsume = res.data.result.minRateConsume;
        this.maxRateConsume = res.data.result.maxRateConsume;
        if (this.$store.state.currentSystem === 'web') {
          let result = this.billInfo.agentRateList.filter(value => value.payType === '00')[0];
          let result1 = this.billInfo.agentRateList.filter(value => value.payType === '01')[0];
          result.mercCreditCardRate = this.maxRateConsume;
          result.mercDebitCardRate = this.maxRateConsume;
          result1.mercCreditCardRate = this.maxRateConsume;
          result1.mercDebitCardRate = this.maxRateConsume;
        }
        this.getRateUpValue();
      }).catch(error => {
        console.log(error);
      });
    },
    validateFee() {
      if (/^0(\.\d{1,2})?$/.test(this.billInfo.agentScanVo.mercWeixinFee)) {
        this.billInfo.agentScanVo.mercWeixinFee = this.returnFloat(this.billInfo.agentScanVo.mercWeixinFee);
        this.billInfo.agentScanVo.mercAlipayFee = this.billInfo.agentScanVo.mercWeixinFee;
        this.billInfo.agentScanVo.mercYinlianFee = this.billInfo.agentScanVo.mercWeixinFee;
        this.errorMessageFee = '';
      } else {
        this.errorMessageFee = '费率最多四位小数';
      }
    },
    returnFloat(val) {
      var value = Math.round(parseFloat(val) * 10000) / 10000;
      var xsd = value.toString().split('.');
      if (xsd.length == 1) {
        value = value.toString() + '.0000';
      }
      if (xsd.length > 1) {
        const length = xsd[1].length;
        if (length === 1) {
          value = value.toString() + '000';
        } else if (length === 2) {
          value = value.toString() + '00';
        } else if (length === 3) {
          value = value.toString() + '0';
        }
      }
      return value;
    },
    validateRate(row, field) {
      if (/^0(\.\d{1,4})?$/.test(row[field])) {
        if (row[field] < this.minRateConsume || row[field] > this.maxRateConsume) {
          this.validates[row.payType][field] = `费率区间为${this.minRateConsume}~${this.maxRateConsume}`;
        } else {
          row[field] = this.returnFloat(row[field]);
          if (row.payType === '00') {
            let result = this.billInfo.agentRateList.filter(value => value.payType === '03')[0];
            result[field] = this.returnFloat(parseFloat(row[field]) + (parseFloat(this.upRateValue) || 0));
          }
          this.validates[row.payType][field] = '';
        }
      } else {
        this.validates[row.payType][field] = '费率最多四位小数';
      }
    },
    validateFeetop(row, field) {
      if (/^(0|[1-9][0-9]*)+(\.[0-9]{1})?$/.test(row[field])) {
        if (row.payType === '00') {
          let result = this.billInfo.agentRateList.filter(value => value.payType === '03')[0];
          result[field] = row[field];
        }
        this.validates[row.payType][field] = '';
      } else {
        this.validates[row.payType][field] = '封顶最多一位小数';
      }
    },
    async submit() {
      let isError = [];
      Object.keys(this.validates).forEach(item => {
        isError = isError.concat(Object.keys(this.validates[item]).filter(key => this.validates[item][key] !== ''));
      });
      const agentRateList = this.billInfo.agentRateList.map((item, index) => {
        let result = this.$store.state.agentInfo.agentRateList.filter(data => data.payType === item.payType)[0];
        return Object.assign({}, item, result);
      });
      const agentScanVo = Object.assign({}, this.billInfo.agentScanVo, this.$store.state.agentInfo.agentScanVo);


      const data = Object.assign({}, this.$store.state.agentInfo, {
        agentRateList,
        agentScanVo
      });

      let isNull = [];
      this.billInfo.agentRateList.forEach(item => {
        isNull = isNull.concat(Object.keys(item).filter(key => item[key] === ''));
      });

      if (!isNull.length && !isError.length && this.errorMessageFee === '') {
        const toast = this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner'
        });

        if (this.$store.state.currentSystem === 'web' && (this.$store.state.rateInfo.checkVersion === 1 || this.$store.state.version === '1')) {
          let hasUpdate = await this.$http.post({
            url: '/csps-api/shareAd/selectTempRateConf',
            data: this.$store.state.rateInfo
          });

          if (hasUpdate.data.result.effectiveStatus === '01') {
            this.$toast('有未生效费率');
            return false;
          } else {
            if (hasUpdate.data.result.upStatus === '01') {
              let newRate = await this.$http.post({
                url: '/csps-api/shareAd/selectInvitRateConf',
                data: {
                  agentId: data.pagentId
                }
              });

              if (newRate.data.result.tip) {
                this.$toast('费率倒挂');
                return false;
              }
              const rateInfo = newRate.data.result;
              data.agentRateList.forEach((item, index) => {
                Object.keys(item).forEach(key => {
                  let result = rateInfo.agentRateTempInfoVoList.filter(value => value.payType === item.payType)[0];
                  item[key] = result[key] || 0;
                  if (key === 'debitCardRate' || key === 'creditCardRate') {
                    item[key] = this.returnFloat(item[key]);
                  }
                });
              });
              Object.keys(data.agentScanVo).forEach(key => {
                data.agentScanVo[key] = rateInfo.agentRateTempInfoVoList.filter(value => value.payType === '04')[0].mercDebitCardRate;
              });
            }
          }
        }

        console.log(data);
        let requestUrl = data.agentId ? '/csps-api/agentInfo/updateAgentInfo' : '/csps-api/agentInfo/addAgentInfo';
        this.$http.post({
          url: requestUrl,
          data
        }).then(res => {
          toast.clear();
          console.log(res);
          const msg = data.agentType === '2' ? '开通成功' : '提交成功，请耐心等待审核结果';
          this.$dialog.alert({
            title: '提示',
            message: msg
          }).then(() => {
            if (this.$store.state.currentSystem === 'app') {
              if (data.agentId) {
                if (/android/i.test(navigator.userAgent)) {
                  window.android.reCommitOrgAuthSuccess()();
                };
              } else {
                if (/android/i.test(navigator.userAgent)) {
                  window.android.finishActivity();
                };
              }
              if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                window.webkit.messageHandlers.goBack.postMessage(null);
              };
            } else {
              this.$router.push('/selectOrgType');
            }
          });
        }).catch(error => {
          console.log(error);
        });
      } else {
        this.$toast('请填写正确的信息');
      }
    }
  }
};
</script>

<style scoped>
.cell_left_text{
  max-width: 110px;
}
.radio{
  display: flex;
  align-items: center;
}
.radio>div:first-child{
  margin-right: 10px;
}
.padding_box{
  padding: 0 10%;
}
.btn{
  display: block;
  background-color: #1D7BF9;
  margin: 10% 0;
  width: 100%;
  line-height: 40px;
  border-radius: 20px;
  border: none;
  outline: none;
  color: #ffffff;
}
</style>